import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

// Google Workspace connection of a server (#763)

export function useGoogle(serverId: string) {
  const api = useApiClient();
  return useQuery({ queryKey: ['google', serverId], queryFn: () => api.google.status(serverId) });
}

/** Opens Google's consent page; the webapp's /google/callback completes it */
export function useConnectGoogle(serverId: string) {
  const api = useApiClient();
  return useMutation({
    mutationFn: () => api.google.connect(serverId),
    onSuccess: ({ url }) => { window.location.assign(url); },
  });
}

export function useDisconnectGoogle(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.google.disconnect(serverId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['google', serverId] });
      void qc.invalidateQueries({ queryKey: ['notification-stats', serverId] });
    },
  });
}
